import React from "react";
import { LegalPage } from "./LegalPage.js";
import { PRIVACY_SECTIONS } from "./content.js";

export function PrivacyPage() {
  return <LegalPage title="Privacy Policy" sections={PRIVACY_SECTIONS} />;
}
